<script lang="ts" setup>
import ProductText from '~/components/products/ProductText.vue'
import Page from '~/enums/page'

defineProps<{
  label: string
  text: string
}>()
</script>

<template>
  <div class="flex items-stretch justify-between">
    <div class="flex flex-col">
      <ProductText class="mb-2" :text="label" />

      <p class="!mb-0 text-sm leading-[1.43] tracking-[-0.01em] text-main-dark md:text-base md:leading-normal">
        {{ text }}
      </p>
    </div>

    <NuxtLink class="relative flex items-center !no-underline" :to="Page.Cart">
      <div class="relative mr-2 flex [&>*]:relative [&>*]:!size-10 [&>*]:md:!size-[44px]">
        <slot />
      </div>

      <SvgIcon class="!size-5 md:!size-[19px]" name="outlined/ui-next-arrow" />
    </NuxtLink>
  </div>
</template>
